import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.gray100};
`;

export const MainContent = styled.main<{ $isCollapsed?: boolean; $fullHeight?: boolean }>`
  flex: 1;
  width: 100%;
  min-height: 0;
  box-sizing: border-box;
  padding: ${({ theme, $fullHeight }) => ($fullHeight ? '8px 12px 12px' : theme.spacing[3])};
  ${({ $fullHeight }) => ($fullHeight ? 'display: flex; flex-direction: column; height: calc(100vh - 64px); max-height: calc(100vh - 64px); overflow: hidden;' : '')}

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme, $fullHeight }) => ($fullHeight ? '10px 14px 14px' : theme.spacing[4])};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding: ${({ theme, $fullHeight }) => ($fullHeight ? '12px 16px 16px' : theme.spacing[4])};
    margin-left: ${({ $isCollapsed }: { $isCollapsed?: boolean }) => $isCollapsed ? '80px' : '280px'};
    width: auto;
    transition: margin-left 0.3s ease;
  }
`;
